export const SERVICES = [
    {
        id: "standard-cut",
        name_zh: "标准精剪",
        name_en: "Signature Cut",
        price: 45,
        suffix_zh: "",
        suffix_en: "",
        duration_zh: "约 40 分钟",
        duration_en: "~40 min",
        desc_zh: "沟通需求、精剪造型、冲洗清洁，一次到位。",
        desc_en: "Consultation, precision cut, rinse & finish.",
        features_zh: ["发型沟通设计", "精剪 + 造型", "冲洗清洁"],
        features_en: ["Style consultation", "Precision cut + styling", "Rinse & clean-up"],
    },
    {
        id: "deluxe-cut-shave",
        name_zh: "豪华剪发 + 热毛巾修面",
        name_en: "Deluxe Cut + Hot Towel Shave",
        price: 85,
        suffix_zh: "",
        suffix_en: "",
        duration_zh: "约 75 分钟",
        duration_en: "~75 min",
        desc_zh: "深夜全套：精剪造型加热毛巾直剃修面，焕新出门。",
        desc_en: "The full midnight ritual: precision cut plus hot-towel straight-razor shave.",
        features_zh: ["标准精剪全部内容", "热毛巾软化", "直剃刀修面", "须后护理"],
        features_en: ["Everything in Signature Cut", "Hot towel prep", "Straight-razor shave", "Aftershave care"],
        featured: true,
    },
    {
        id: "beard-sculpt",
        name_zh: "胡须雕刻",
        name_en: "Beard Sculpting",
        price: 35,
        suffix_zh: "",
        suffix_en: "",
        duration_zh: "约 30 分钟",
        duration_en: "~30 min",
        desc_zh: "修形、开线、轮廓雕刻，让胡须成为造型的一部分。",
        desc_en: "Shape, line-up and contour sculpting — make the beard part of the look.",
        features_zh: ["胡须修形", "轮廓开线", "热毛巾护理"],
        features_en: ["Beard shaping", "Crisp line-up", "Hot towel finish"],
    },
    {
        id: "color-style",
        name_zh: "染发造型",
        name_en: "Color & Styling",
        price: 120,
        suffix_zh: "起",
        suffix_en: "+",
        duration_zh: "约 120 分钟",
        duration_en: "~120 min",
        desc_zh: "潮色、挑染、局部提亮，深夜变身计划。预约时请备注想要的颜色。",
        desc_en: "Full color, highlights or accents — your after-dark transformation. Note your target shade when booking.",
        features_zh: ["色彩沟通", "染发 / 挑染", "造型定型"],
        features_en: ["Color consultation", "Dye / highlights", "Final styling"],
    },
    {
        id: "perm-style",
        name_zh: "烫发造型",
        name_en: "Perm & Texture",
        price: 150,
        suffix_zh: "起",
        suffix_en: "+",
        duration_zh: "约 150 分钟",
        duration_en: "~150 min",
        desc_zh: "冷烫、韩式纹理烫、蓬松定型，睡一觉迎接新发型。预约时请备注发长与想要的卷度。",
        desc_en: "Cold perm, Korean texture waves and volume setting. Note your hair length and desired curl when booking.",
        features_zh: ["发质与卷度沟通", "冷烫 / 纹理烫", "护理与定型"],
        features_en: ["Hair & curl consultation", "Cold / texture perm", "Treatment & setting"],
    },
];

export const GALLERY = [
    {
        id: 1,
        title_zh: "美式复古渐变剪裁",
        title_en: "Precision Skin Fade & Lineup",
        category: "Haircut",
        url: "https://images.unsplash.com/photo-1562004760-aceed7bb0fe3?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMzJ8MHwxfHNlYXJjaHwzfHxtZW5zJTIwaGFpcmN1dCUyMGJlZm9yZSUyMGFmdGVyJTIwYmFyYmVyJTIwdmludGFnZSUyMHN0eWxpbmd8ZW58MHx8fHwxNzkxOTc2OTk3fDA&ixlib=rb-4.1.0&q=85",
        tags: ["Mid-Fade", "Midnight Special"],
    },
    {
        id: 2,
        title_zh: "深夜雕刻与胡须理容",
        title_en: "Classic Hot Towel Beard Sculpting",
        category: "Beard & Shave",
        url: "https://images.unsplash.com/photo-1635273051937-a0ddef9573b6?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMzJ8MHwxfHNlYXJjaHxfHxtZW5zJTIwaGFpcmN1dCUyMGJlZm9yZSUyMGFmdGVyJTIwYmFyYmVyJTIwdmludGFnZSUyMHN0eWxpbmd8ZW58MHx8fHwxNzkxOTc2OTk3fDA&ixlib=rb-4.1.0&q=85",
        tags: ["Beard Craft", "Straight Razor"],
    },
    {
        id: 3,
        title_zh: "纹理质感碎发剪裁",
        title_en: "Modern Textured Crop & Matte Finish",
        category: "Haircut",
        url: "https://images.unsplash.com/photo-1578390432942-d323db577792?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMzJ8MHwxfHNlYXJjaHwyfHxtZW5zJTIwaGFpcmN1dCUyMGJlZm9yZSUyMGFmdGVyJTIwYmFyYmVyJTIwdmludGFnZSUyMHN0eWxpbmd8ZW58MHx8fHwxNzkxOTc2OTk3fDA&ixlib=rb-4.1.0&q=85",
        tags: ["Textured Crop", "Urban Vibe"],
    },
    {
        id: 4,
        title_zh: "夜间极简修剪与定型",
        title_en: "Executive Midnight Scissor Grooming",
        category: "Executive",
        url: "https://images.unsplash.com/photo-1647140655214-e4a2d914971f?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxODh8MHwxfHNlYXJjaHwyfHxiYXJiZXIlMjBoYWlyY3V0fGVufDB8fHx8MTc5MTk3NzAwNHww&ixlib=rb-4.1.0&q=85",
        tags: ["Scissors Only", "Natural Flow"],
    },
    {
        id: 5,
        title_zh: "潮色染发与局部提亮",
        title_en: "Custom Color Dye & Bleach",
        category: "Coloring",
        url: "https://images.unsplash.com/photo-1605497788044-5a32c7078486?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxODh8MHwxfHNlYXJjaHwxfHxiYXJiZXIlMjBoYWlyY3V0fGVufDB8fHx8MTc5MTk3NzAwNHww&ixlib=rb-4.1.0&q=85",
        tags: ["Cyber Dye", "Blow Dry"],
    },
    {
        id: 6,
        title_zh: "清爽极简短发",
        title_en: "Sharp Buzz Fade & Hairline Contour",
        category: "Haircut",
        url: "https://images.unsplash.com/photo-1567894340315-735d7c361db0?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMzN8MHwxfHNlYXJjaHwxfHxiYXJiZXJzaG9wJTIwcG9ydHJhaXR8ZW58MHx8fHwxNzkxOTc2OTk3fDA&ixlib=rb-4.1.0&q=85",
        tags: ["Buzz Cut", "Sharp Line"],
    },
];

export const HERO_IMG =
    "https://images.unsplash.com/photo-1599351431202-1e0f0137899a?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxODh8MHwxfHNlYXJjaHw0fHxiYXJiZXIlMjBoYWlyY3V0fGVufDB8fHx8MTc5MTk3NzAwNHww&ixlib=rb-4.1.0&q=85";

export const STORY_IMG =
    "https://images.unsplash.com/photo-1503951914875-452162b0f3f1?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxODh8MHwxfHNlYXJjaHwzfHxiYXJiZXIlMjBoYWlyY3V0fGVufDB8fHx8MTc5MTk3NzAwNHww&ixlib=rb-4.1.0&q=85";

export const TESTIMONIALS = [
    {
        name: "阿凯 Kai",
        role_zh: "软件工程师",
        role_en: "Software Engineer",
        quote_zh: "连续加班两个月，只有 9CUT 在我下班后还开着。凌晨一点的渐变剪裁，第二天站会整个人都精神了。",
        quote_en: "Two months of overtime and 9CUT was the only place still open when I got off work. A 1 AM fade — I walked into standup the next day a new man.",
        time: "01:30 AM",
        avatar:
            "https://images.unsplash.com/photo-1598524374912-6b0b0bab43dd?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMzN8MHwxfHNlYXJjaHwyfHxiYXJiZXJzaG9wJTIwcG9ydHJhaXR8ZW58MHx8fHwxNzkxOTc3MDA0fDA&ixlib=rb-4.1.0&q=85",
    },
    {
        name: "Dr. Lin",
        role_zh: "急诊科医生",
        role_en: "ER Doctor",
        quote_zh: "夜班下来说是凌晨两点，他真的等我。安静、专业、不推销，热毛巾修面是下夜班后最好的奖励。",
        quote_en: "My shift ended at 2 AM and he actually waited for me. Quiet, professional, zero upselling — the hot towel shave is the best post-shift reward.",
        time: "02:15 AM",
        avatar:
            "https://images.unsplash.com/photo-1672642150228-3fcd5826ec26?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMzN8MHwxfHNlYXJjaHw0fHxiYXJiZXJzaG9wJTIwcG9ydHJhaXR8ZW58MHx8fHwxNzkxOTc2OTk3fDA&ixlib=rb-4.1.0&q=85",
    },
    {
        name: "Marco",
        role_zh: "夜店经理",
        role_en: "Club Manager",
        quote_zh: "我的白天从下午五点才开始。在这里剪了半年，出品稳定，威士忌也不错。深夜理发这件事，他做成了仪式感。",
        quote_en: "My day starts at 5 PM. Six months in, the cuts are consistent and the whisky is decent. He's turned a midnight haircut into a ritual.",
        time: "23:45 PM",
        avatar:
            "https://images.unsplash.com/photo-1593702295094-aea22597af65?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMzJ8MHwxfHNlYXJjaHw0fHxtZW5zJTIwaGFpcmN1dCUyMGJlZm9yZSUyMGFmdGVyJTIwYmFyYmVyJTIwdmludGFnZSUyMHN0eWxpbmd8ZW58MHx8fHwxNzkxOTc2OTk3fDA&ixlib=rb-4.1.0&q=85",
    },
];

export const TIME_SLOTS = ["21:00", "22:00", "23:00", "00:00", "01:00", "02:00", "03:00"];

export const isOpenNow = () => {
    const h = new Date().getHours();
    return h >= 21 || h < 4;
};

export const serviceName = (id, lang) => {
    const s = SERVICES.find((x) => x.id === id);
    if (!s) return id;
    return lang === "zh" ? s.name_zh : s.name_en;
};
